export default "__VITE_ASSET__CPYIoWtj__"